import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PreviewDrawerLineStyled } from "@ryde/controls";
import { RESTORE_SUMMARY_PATTERN } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { ProcessDrawerContext } from "../process-drawer-context";

// Replaces the generic "Successful" line for the backup-restore process with its own
// inserted/updated/skipped summary, parsed from the process completion log line.
export const ProcessStatisticBackupRestore: FC = () => {
  const { t } = useTranslation();
  const { currentProcess } = useContext(ProcessDrawerContext);

  const summary = currentProcess?.logs?.find(line => line.includes("inserted"));
  const counts = summary?.match(RESTORE_SUMMARY_PATTERN);
  const inserted = counts ? Number(counts[1]) : 0;
  const updated = counts ? Number(counts[2]) : 0;
  const deleted = counts ? Number(counts[3]) : 0;
  const skipped = counts ? Number(counts[4]) : 0;

  return (
    <>
      <PreviewDrawerLineStyled $numberColor={rydeColors.green}>
        <span>{t("backup.restore.inserted", "Inserted")}</span>
        <span>{inserted}</span>
      </PreviewDrawerLineStyled>
      <PreviewDrawerLineStyled $numberColor={rydeColors.green}>
        <span>{t("backup.restore.updated", "Updated")}</span>
        <span>{updated}</span>
      </PreviewDrawerLineStyled>
      <PreviewDrawerLineStyled $numberColor={rydeColors.red}>
        <span>{t("backup.restore.deleted", "Deleted")}</span>
        <span>{deleted}</span>
      </PreviewDrawerLineStyled>
      <PreviewDrawerLineStyled $numberColor={rydeColors.orange}>
        <span>{t("backup.restore.skipped", "Skipped")}</span>
        <span>{skipped}</span>
      </PreviewDrawerLineStyled>
    </>
  );
};
